import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { orderStatus, fmFilterStatuses } from '../../utils/constant';
import {
  getLink,
  getButton,
  Tooltip,
  exactCompareArray,
  createGetStatusFiltersPayload
} from '../dashboardCommon/utils';

const getStatus = order => {
  const local = useLocaleContext();

  const {
    cybersecurity: {
      dashboard: { status }
    }
  } = local === 'en-US' ? EN : FR;

  const incomplete = order === orderStatus.incomplete;
  const pendingValidation = order === orderStatus.pendingValidation;
  const contractSend = order === orderStatus.contractSend;
  const contractSigned = order === orderStatus.contractSigned;
  const completed = order === orderStatus.submitted;
  const orderCanceled = order === orderStatus.canceled;
  const sendBacktoAccountManager =
    order === orderStatus.SendBacktoAccountManager;

  const statusList = {
    [incomplete]: status.orderIncomplete,
    [pendingValidation]: status.pendingValidation,
    [contractSend]: status.contractSent,
    [contractSigned]: status.contractSigned,
    [completed]: status.orderCompleted,
    [orderCanceled]: status.orderCanceled,
    [sendBacktoAccountManager]: status.sendBacktoAccountManager
  };

  return statusList.true;
};

const getOrderType = (productSelected = []) => {
  let type = '';
  if (productSelected.length) {
    type = productSelected;
  } else {
    type = '-';
  }
  return type;
};

const filterValueToStatusesMap = {
  [fmFilterStatuses.incomplete]: {
    orderStatus: orderStatus.incomplete
  },
  [fmFilterStatuses.submitted]: {
    orderStatus: orderStatus.submitted
  },
  [fmFilterStatuses.pendingValidation]: {
    orderStatus: orderStatus.pendingValidation
  },
  [fmFilterStatuses.orderCanceled]: {
    orderStatus: orderStatus.canceled
  },
  [fmFilterStatuses.contractSigned]: {
    orderStatus: orderStatus.contractSigned
  },
  [fmFilterStatuses.contractSent]: {
    orderStatus: orderStatus.contractSend
  },
  [fmFilterStatuses.SendBacktoAccountManager]: {
    orderStatus: orderStatus.SendBacktoAccountManager
  }
};

const getStatusFiltersPayload = createGetStatusFiltersPayload(
  filterValueToStatusesMap
);

export {
  getLink,
  getButton,
  Tooltip,
  getStatus,
  getOrderType,
  exactCompareArray,
  getStatusFiltersPayload
};
